import { isAfter } from 'date-fns';

const stripCurrentSession = (items, now) => {
  return items?.filter(item => isAfter(new Date(item.start), new Date(now)));
};

export default stripCurrentSession;
